import { cn } from "@/lib/utils";

interface TitleProps {
  className?: string;
  children: React.ReactNode;
}
export const Title: React.FC<TitleProps> = ({ children, className }) => {
  return <h2 className={cn(`text-2xl font-bold`, className)}>{children}</h2>;
};
